<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :multiple="multiple"
            :showAdd="showAdd"
            :dense="dense"
            :selectAll="selectAll"
            :auto-complete="autoComplete"
            :disabled="disabled"
            @onSelectAll="$emit('onSelectAll', $event)"
        />
        <sys-register-ambience-type @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectAmbienceType',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        multiple: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        onlyInPerson: {
            type: Boolean,
            default: false
        },
        onlyWithLink: {
            type: Boolean,
            default: false
        },
        campusId: {
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        
    },
    watch: {

        selected(val){
            this.$emit('update:model', val);
        },

        campusId(){
            this.getItems();
        },

        model(val){
            const hydrated = this.hydrateFromModel(val);
            // Evita loop: só atualiza se o conteúdo (não a referência) mudou.
            if (!this.sameSelection(this.selected, hydrated)) {
                this.selected = hydrated;
            }
        },
    },
    methods: {
        ...mapActions('ambienceType', ['ActionFindAmbienceTypes']),

        hydrateFromModel(val) {
            if (val == null) {
                return this.multiple ? [] : null;
            }
            if (!this.multiple) {
                return val;
            }
            if (!Array.isArray(val)) {
                return [];
            }
            return val
                .map(item => {
                    if (item && typeof item === 'object') return item;
                    const id = Number.parseInt(item, 10);
                    return Number.isInteger(id) ? this.items.find(i => i.id === id) : null;
                })
                .filter(Boolean);
        },

        sameSelection(a, b) {
            if (a === b) return true;
            if (!Array.isArray(a) || !Array.isArray(b)) return false;
            if (a.length !== b.length) return false;
            const idOf = x => (x && typeof x === 'object') ? x.id : Number.parseInt(x, 10);
            const idsA = a.map(idOf).sort();
            const idsB = b.map(idOf).sort();
            return idsA.every((v, i) => v === idsB[i]);
        },

        async getItems() {

            this.loading = true;

            var payload = {
                column_order: 'name',
                find_columns: {
                    active: 1
                }
            };

            if(this.onlyInPerson){
                payload.find_columns.is_virtual = 0
            }

            if(this.onlyWithLink){
                payload.find_columns.allow_ambience_link = 1;
            }

            if(this.campusId && this.campusId.length !== 0){
                payload.filter_relations = [
                    {
                        name:   'ambiences',
                        key:    'campus_id',
                        value:  this.campusId,
                    }
                ];
            }

            // Captura model antes do await: se algum reset disparar o watcher
            // de selected, o emit update:model sobrescreve this.model.
            const initialModel = this.model;

            await this.ActionFindAmbienceTypes(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.hydrateFromModel(initialModel);
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>